import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/auth'

import { getSessionFromResponse } from './Serializers'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardAuthApiClient: Client<paths>
}

export const getCurrentUserSessions = async () => {
    const { data, error } = await globalThis.DashboardAuthApiClient.GET(
        '/v1/public/auth/sessions',
    )

    if (error) {
        throw error
    }
    const { items = [] } = data
    return items.map(getSessionFromResponse)
}

export const getUserSessions = async (id: string) => {
    const { data, error } = await globalThis.DashboardAuthApiClient.GET(
        '/v1/public/auth/user/{user_id}/sessions', {
            params: {
                path: {
                    user_id: Number(id),
                },
            },
        },
    )

    if (error) {
        throw error
    }
    const { items = [] } = data
    return items.map(getSessionFromResponse)
}

export const deleteSession = async (id: string) => {
    const { error } = await globalThis.DashboardAuthApiClient.DELETE(
        '/v1/public/auth/sessions/{session_id}', {
            params: {
                path: {
                    session_id: id,
                },
            },
        },
    )

    if (error) {
        throw error
    }
    return true
}
